<template>
    <v-container fluid>
        <div v-if="!loading">
            <v-row class="my-2 subtitle-2 secondary--text pl-12">
                Intermediary indicators
            </v-row>
            <v-divider />
            <!--table 1 head-->
            <v-row class="subtitle-2" no-gutters>
                <v-col v-for="(item, i) in headers.tab_1" :key="i" class="tabCell" 
                    :class="item.style">
                    {{ item.title }}
                </v-col>
            </v-row>
            <!--Intermediary indicators tab 1-->
            <div v-if="intermediary?.length > 0">
                <div v-for="item in intermediary" :key="`1_${item.id}`">
                    <v-row no-gutters>
                        <v-col class="text-left tabCell">{{ item.team?.name }}</v-col>
                        <v-col class="text-center tabCell">{{ formatNumber(item.production_assets, 0)}}</v-col>
                        <v-col class="text-center tabCell">{{ formatNumber(item.retail_assets, 0) }}</v-col>
                        <v-col class="text-center tabCell">{{ formatNumber(item.production_depreciation, 0) }}</v-col>
                        <v-col class="text-center tabCell">{{ formatNumber(item.retail_depreciation, 0) }}</v-col>
                        <v-col class="text-center tabCell">{{ formatNumber(item.franchise_cost, 0) }}</v-col>
                        <v-col class="text-center tabCell">{{ formatNumber(item.franchise_fee, 0) }}</v-col>
                        <v-col class="text-center tabCell">{{ formatNumber(item.retail_entry, 0) }}</v-col>
                        <v-col class="text-center tabCell">{{ formatNumber(item.retail_annual_fee, 0) }}</v-col>
                        <v-col class="text-center tabCell">{{ formatNumber(item.market_research, 0) }}</v-col>
                    </v-row>
                </div>
                <v-divider class="mt-12"/>
                <!--table 2 head-->
                <v-row class="subtitle-2" no-gutters>
                    <v-col v-for="(item, i) in headers.tab_2" :key="i" class="tabCell" 
                        :class="item.style">
                        {{ item.title }}
                    </v-col>
                </v-row> 
                
                <!--Intermediary indicators tab 2-->
                <div v-for="item in intermediary" :key="`2_${item.id}`">
                    <v-row no-gutters>
                        <v-col class="text-left tabCell">{{ item.team?.name }}</v-col>
                        <v-col class="text-center tabCell">{{ formatNumber(item.invest_assets, 0) }}</v-col>
                        <v-col class="text-center tabCell">{{ formatNumber(item.invest_retail, 0) }}</v-col>
                        <v-col class="text-center tabCell">{{ formatNumber(item.invest_promo, 0) }}</v-col>
                        <v-col class="text-center tabCell">{{ formatNumber(item.running_promo, 0) }}</v-col>
                        <v-col class="text-center tabCell">{{ formatNumber(item.retail_writte_off, 0) }}</v-col>
                        <v-col class="text-center tabCell">{{ formatNumber(item.operate_retail, 0) }}</v-col>
                        <v-col class="text-center tabCell">{{ formatNumber(item.inventories, 0) }}</v-col>
                        <v-col class="text-center tabCell">{{ formatNumber(item.inventories_writte_off, 0) }}</v-col>
                        <v-col class="text-center tabCell">{{ formatNumber(item.invest_assets_writte_off, 0) }}</v-col>
                    </v-row>
                </div>
                <div class="mb-4"></div>
            </div>
        </div>
        <!--!loading-->
        <div v-else class="text-center">
            <loader></loader>
        </div>
    </v-container>
</template>
<script>
import Loader from '../../../layouts/Loader.vue';
import { localeNumber, roundNumber } from '../../../functions/common';
export default {
    data() {
        return {
            headers: {
                tab_1: [
                    { title: 'Team', style: 'text-left' },
                    { title: 'Production assets', style: 'text-center' },
                    { title: 'Retail assets', style: 'text-center' },
                    { title: 'Depreciation production', style: 'text-center' },
                    { title: 'Depreciation retail', style: 'text-center' },
                    { title: 'Francise cost', style: 'text-center' },
                    { title: 'Francise fee', style: 'text-center' },
                    { title: 'Retail entry', style: 'text-center' },
                    { title: 'Retail annual fee', style: 'text-center' },
                    { title: 'Market research', style: 'text-center' },
                    
                    ],
                tab_2: [
                    { title: 'Team', style: 'text-left' },
                    { title: 'Invest assets', style: 'text-center' },
                    { title: 'Invest retail', style: 'text-center' },
                    { title: 'Invest promo', style: 'text-center' },
                    { title: 'Running promo', style: 'text-center' },
                    { title: 'Retail invest write off', style: 'text-center' },
                    { title: 'Operate retail', style: 'text-center' },
                    { title: 'Inventories current round', style: 'text-center' },
                    { title: 'Inventories write off', style: 'text-center' },
                    { title: 'Assets invest write off', style: 'text-center' },
                ]
            } 
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        locale() {
            return this.$store.getters.locale;
        },
        intermediary() {
            return this.$store.getters.intermediary_all;
        }
    },
    methods: {
        localeNumber(number) {
            return localeNumber(number, this.locale)
        },
        formatNumber(num, dec) {
            return localeNumber(roundNumber(num, dec), this.locale);
        }
    },
    components: { Loader }
}
</script>